import {
  Component, OnInit, ViewChild,
  ElementRef, AfterViewInit, ChangeDetectorRef,
  HostListener, DoCheck, AfterViewChecked, EventEmitter, Output
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppConfigService } from '../../framework/services/app-config.service';
import { LinkMasterService } from '../../framework/services/link-master.service';
import { LinkMastermodel } from '../link-master/link-master-model';
import { disableDebugTools, DomSanitizer, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/framework/services/language.service';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { MsalService } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';
import { UserService } from '../../framework/services/userservice';
import { CategoryConstant } from '../shared/app-constants/category-constants';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { EditUser } from '../user-management/user-management.component';
import { UserManagementService } from 'src/framework/services/user-management.service';
import { FileUpload } from 'primeng';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserMemoryService } from 'src/framework/services/user-memory.service';
import { Observable, Subject, timer, Subscription } from 'rxjs';
import { startWith, take, switchMap, map, ignoreElements } from 'rxjs/operators';
import { runInThisContext } from 'vm';
import { HomeService } from 'src/framework/services/home.service';
import { CommonService } from 'src/framework/services/common.service';
declare function toggleMenu();

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  providers: [Location, MessageService, { provide: LocationStrategy, useClass: PathLocationStrategy }]
})
export class NavMenuComponent implements OnInit, AfterViewInit, DoCheck, AfterViewChecked {

  public contactactive = false;
  public isPageReady: boolean = true;
  public minutesDisplay = 0;
  public secondsDisplay = 0;
  public endTime = 3;
  public sessionEndTime = 1;//In minutes
  public sessionEndTimeNotify: number = 0;//In minutes
  public showConfirmation: boolean = false;
  //public renewsessiontoken: boolean = false;
  public notificationStatusList;
  public isUserTriggredLogout: boolean = false;
  public languageName="EN";

  languageLists=[];
  formal=true;

  unsubscribe$: Subject<void> = new Subject();
  reset$: Subject<void> = new Subject();
  //reset$: Subject<void> = new Subject();
  //timerSubscription: Subscription;
  //sessiontimer: Subscription;

  isExpanded = false;
  labelsLoaded = false;
  languageList: SelectItem[];
  showEngSecondaryNav: boolean = false;
  showAdminSecondaryNav: boolean = false;
  aboutrestructuringlink: string;
  LinkMastermodel: LinkMastermodel[];
  showDocumentSecondaryNav: boolean = true;
  href = "";
  newmsalsvc: MsalService;
  isLabelLoaded: boolean = false;
  isTokenRenewed: boolean = false;
  displayUserDialog = false;
  isAuthorizedUser = false;
  userTitles = [];
  maxRenewTokenCount = 3;


  searchtxt: "";
  sessionId: '';
  count: 0;

  modalShow = false;
  public sessionReq = {
    userEmail: null,
    sessionId: null
  }

  //Initialize variables
  public userName = "";
  public statusList;
  public isUserExist = null;
  public IsAdmin = false;
  public isPublicUserExist = null;
  public userData: any;
  chooseImageHeading: string = 'Choose Image';
  externalContactModel: EditUser;
  @ViewChild(FileUpload) ctrlImageUpload: FileUpload;
  pUpload: any;
  imageURL: string;
  userEditForm: FormGroup;
  isImageUploaded = false;
  showOnlyProfile = true;
  isClickComplete = false;
  @ViewChild('approvalMgt', { static: true, read: ElementRef }) approvalMgt: ElementRef
  @ViewChild('managementNav', { static: true, read: ElementRef }) managementNav: ElementRef

  @ViewChild('openNav', { static: true, read: ElementRef }) openNav: ElementRef;
  @ViewChild('documentSubNav', { static: true, read: ElementRef }) documentSubNav: ElementRef;
  @ViewChild('addEngagement', { static: true, read: ElementRef }) addEngagement: ElementRef;
  selectedLanguage: { name: string; };
  MappedLanguage = [];
  MappedEnglishLanguage = [];
  MappedLinksLanguage = [];
  MappedLinksEnglishLanguage = [];
  title = 'Restructuring Document Centre 2.0';
  MappedUserLanguage = [];
  MappedUserEnglishLanguage = [];

  MappedLangLanguage = [];
  MappedLangEnglishLanguage = [];
  MappedTitleLanguage = [];
  MappedTitleEnglishLanguage = [];


  userActivity: any;
  languagechanged=false;
  appLanguage: any;
  userActivityAfterNotified: any;
  userInactive: Subject<any> = new Subject();
  notifiedInactiveUser: Subject<any> = new Subject();
  constructor(private usermgmtService: UserManagementService,
    private sanitizer: DomSanitizer,
    private appConfigService: AppConfigService,
    private service: LinkMasterService,
    private router: Router,
    private changes: ChangeDetectorRef,
    private languageService: LanguageService,
    private lableCardService: LabelcardMgmtService,
    private msalSvc: MsalService,
    private titleService: Title,
    private messageService: MessageService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private userMemoryService: UserMemoryService,
    private appService: AppConfigService,
    private homeService: HomeService,
    private commonService:CommonService,
    private route: ActivatedRoute,) {
    this.externalContactModel = new EditUser(false, false, "", "", "", "", "", true, 0);
    this.userEditForm = new FormGroup({
      'userId': new FormControl(this.externalContactModel.userId, [Validators.required]),
      'isAdmin': new FormControl(this.externalContactModel.isAdmin, [Validators.required]),
      'isAuthorized': new FormControl(this.externalContactModel.isAuthorized, [Validators.required]),
      'picture': new FormControl(this.externalContactModel.picture, [Validators.required]),
      'title': new FormControl(this.externalContactModel.title, [Validators.required, Validators.email]),
      'designation': new FormControl(this.externalContactModel.designation, [Validators.required]),
      'linkEnglish': new FormControl(this.externalContactModel.linkEnglish, [Validators.required]),
      'linkFrench': new FormControl(this.externalContactModel.linkFrench, [Validators.required]),
      'isDisplays': new FormControl(true)
    });
    if (this.msalSvc.instance.getActiveAccount()!= null) {
      //this.resetTimer();
      
      setTimeout(() => { this.authenticateuser(); }, 2000)
      this.setTimeout();
      this.userInactive.subscribe(() => {
        this.notifyUser();
      });
    }
    else {
      this.languageName="EN"
      this.nonEYEmpLogin();
    }
    this.isExpanded = this.homeService.isHomeSelected;

  }

  setTimeout() {
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), 59 * 60 * 1000);
  }

  setTimeoutForAutoLogout() {
    this.userActivityAfterNotified = setTimeout(() => this.notifiedInactiveUser.next(undefined), 5 * 60 * 1000);
  }

  @HostListener('window:mousemove')
  refreshUserState() {
    clearTimeout(this.userActivity);
    clearTimeout(this.userActivityAfterNotified);
    this.setTimeout();
    if (this.showConfirmation == true) {
      this.setTimeoutForAutoLogout();
    }
  }

  private notifyUser() {
    if (this.showConfirmation == false && this.isTokenRenewed == false) {
      this.showConfirmation = true;
      this.setTimeoutForAutoLogout();
      this.notifiedInactiveUser.subscribe(() => {
        this.logout();
      });
    } else {
      this.showConfirmation = true;
    }
  }


  ngOnInit(): void {
   
    this.commonService.formal.subscribe(updatedTitle => {
      this.formal = updatedTitle;
    })
    this.commonService.getLoggedInUserObs().subscribe((data) =>{
      if(data == true)
        this.authenticateuser() ;
    } );
    this.languageService.currentData.subscribe(data => this.selectedLanguage = data);
    this.languageService.mySubject.subscribe((data) => {
      //call my function
      var languageMappings = data;
      if (languageMappings?.length > 0) {
        var selectedLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Global && item.languageId == this.selectedLanguage['Id']);
        this.MappedLanguage = JSON.parse(selectedLanguageMappings[0].languageMappingJSON);
        var englishLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Global && item.languageId == 1);
        this.MappedEnglishLanguage = JSON.parse(englishLanguageMappings[0].languageMappingJSON);



        var selectedLinkLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Links && item.languageId == this.selectedLanguage['Id']);
        this.MappedLinksLanguage = JSON.parse(selectedLinkLanguageMappings[0].languageMappingJSON);
        var englishLinkLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Links && item.languageId == 1);

        this.MappedLinksEnglishLanguage = JSON.parse(englishLinkLanguageMappings[0].languageMappingJSON);


        var selectedLangLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Language && item.languageId == this.selectedLanguage['Id']);
        this.MappedLangLanguage = JSON.parse(selectedLangLanguageMappings[0].languageMappingJSON);
        var englishLangLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Language && item.languageId == 1);

        this.MappedLangEnglishLanguage = JSON.parse(englishLangLanguageMappings[0].languageMappingJSON);

        var selectedUserLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.UserManagement && item.languageId == this.selectedLanguage['Id']);
        this.MappedUserLanguage = JSON.parse(selectedUserLanguageMappings[0].languageMappingJSON);
        var englishUserLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.UserManagement && item.languageId == 1);

        this.MappedUserEnglishLanguage = JSON.parse(englishUserLanguageMappings[0].languageMappingJSON);


        var selectedUserLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Title && item.languageId == this.selectedLanguage['Id']);
        this.MappedTitleLanguage = JSON.parse(selectedUserLanguageMappings[0].languageMappingJSON);
        var englishUserLanguageMappings = languageMappings.filter(item =>
          item.categoryName == CategoryConstant.Title && item.languageId == 1);

        this.MappedTitleEnglishLanguage = JSON.parse(englishUserLanguageMappings[0].languageMappingJSON);
        if (!this.userData) {
          this.userName = this.globalReplacer('Public');
        }


        this.userTitles = [{ label: this.titleReplacer('Chairman'), value: 'Chairman' },
        { label: this.titleReplacer('President'), value: 'President' },
        { label: this.titleReplacer('Senior Vice President'), value: 'Senior Vice President' },
        { label: this.titleReplacer('Vice President'), value: 'Vice President' },
        { label: this.titleReplacer('Manager'), value: 'Manager' },
        { label: this.titleReplacer('Senior'), value: 'Senior' },
        { label: this.titleReplacer('Staff'), value: 'Staff' },
        { label: this.titleReplacer('Consultant'), value: 'Consultant' },
        { label: this.titleReplacer('Senior Manager'), value: 'Senior Manager' },
        { label: this.titleReplacer('Partner'), value: 'Partner' },
        { label: this.titleReplacer('Associate Partner'), value: 'Associate Partner' },
        { label: this.titleReplacer('Executive Director'), value: 'Executive Director' }
        ];

        this.getLanguages();
        this.labelsLoaded = true;
      }

    });

    // if (this.adalSvc.isAuthenticated) {
    //   this.resetTimer();
    //   this.resetSessionTimer();
    // }

    // this.appConfigService.navDocumentElement = this.openNav.nativeElement;
    // this.appConfigService.documentSubNav = this.documentSubNav.nativeElement;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  titleReplacer(labelKey): string {
    return this.MappedTitleLanguage[labelKey]?.trim() ? this.MappedTitleLanguage[labelKey] ?? 'text not found' : this.MappedTitleEnglishLanguage[labelKey] ?? 'text not found';
  }

  getLanguages() {
    this.appConfigService.getLanguageList().subscribe((response: any) => {
      if (response) {
        this.languageLists = response;
        this.languageList = response.filter(x => x?.isAppLanguage).map(lang => ({
          label: lang.name,
          value: lang.languageId
        }));
        this.checkPublicUsers();

        sessionStorage.setItem('selectedLanguageId', this.languageList[0].value);


        this.route.queryParams.subscribe(params => {
          var languageId=1;
          if(params['lang']){
          this.languageName = params['lang'];
          var lists=this.languageLists.filter(item=>item.languageCode==this.languageName.toUpperCase());
          languageId=lists[0].languageId;
          if(this.selectedLanguage['Id']!=languageId && !this.languagechanged){
          this.appLanguage=lists[0].languageId;
         
          sessionStorage.setItem('selectedLanguageId', languageId.toString());
          this.languageService.changeLanguage({ name: lists[0].name, Id: lists[0].languageId });
          this.lableCardService.getAllMappedLabels(languageId).subscribe
          (
          (resp) => {
            var languageList = resp;
            this.languageService.myDataSetter(languageList);
          });
        }
          }
        });

      


        // this.languageList=languages.forEach(element => {
        //   element.label=this.languageReplacer(element.label);
        // });
      }
    });
  }


  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}


  languageReplacer(labelKey): string {
    return this.MappedLangLanguage[labelKey]?.trim() ? this.MappedLangLanguage[labelKey] ?? 'text not found' : this.MappedLangEnglishLanguage[labelKey] ?? 'text not found';
  }

  userReplacer(labelKey): string {
    return this.MappedUserLanguage[labelKey]?.trim() ? this.MappedUserLanguage[labelKey] ?? 'text not found' : this.MappedUserEnglishLanguage[labelKey] ?? 'text not found';
  }

  globalReplacer(labelKey): string {
    return this.MappedLanguage[labelKey]?.trim() ? this.MappedLanguage[labelKey] ?? 'text not found' : this.MappedEnglishLanguage[labelKey] ?? 'text not found';
  }

  cancel() {
    this.onReset()
  }

  saveEditedUser() {
    this.spinner.show();
    const formData = new FormData();
    this.externalContactModel;
    let imageData;
    imageData = {
      'userId': this.userEditForm.get('userId').value,
      'isAdmin': this.userEditForm.get('isAdmin').value,
      'isAuthorized': this.userEditForm.get('isAuthorized').value,
      'title': this.userEditForm.get('title').value,
      'designation': this.userEditForm.get('designation').value,
      'linkEnglish': this.userEditForm.controls['linkEnglish'].value,
      'linkFrench': this.userEditForm.controls['linkFrench'].value,
      'isDisplay': this.userEditForm.get('isDisplays').value,
      'picFileName': ''
    }
    if (this.pUpload) {

      const fileToUpload = <File>this.pUpload;

      formData.append('file', fileToUpload, fileToUpload.name);
      imageData.picFileName = fileToUpload.name;
    }
    formData.append('fileJson', JSON.stringify(imageData));
    this.usermgmtService.uploadProfilePhoto(formData).subscribe(res => {

      if (res) {
        this.spinner.hide();
        // success
        this.onReset();
        this.getUserRole(this.msalSvc.instance.getActiveAccount().username);
        //newFunction();
        console.log(res);
      } else {
        this.spinner.hide();
        // display error
        this.onReset();
      }


      /*function newFunction() {
        this.getUserRole(this.msalSvc.userInfo.profile.upn);
      }*/
    });
  }


  EditUser() {
    this.displayUserDialog = true;
    this.userEditForm.controls['userId'].setValue(this.userData.userId);
    this.userEditForm.controls['isAdmin'].setValue(this.userData.isAdmin);
    this.userEditForm.controls['isAuthorized'].setValue(this.userData.isAuthorized);
    this.userEditForm.controls['title'].setValue(this.userData.title);
    this.userEditForm.controls['designation'].setValue(this.userData.designation);
    this.userEditForm.controls['linkEnglish'].setValue(this.userData.linkEnglish);
    this.userEditForm.controls['linkFrench'].setValue(this.userData.linkFrench);
    this.userEditForm.controls['isDisplays'].setValue(this.userData.is_Display);
    if (this.userData.picture != "") {

      this.usermgmtService.downloadImage(this.userData.picture)
        .subscribe((data :any)=> {
          this.ctrlImageUpload.files.push(new File([data], this.userData.picture));
          this.pUpload = new File([data], this.userData.picture);
          var blob = new Blob([data], { type: "image/png" });

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            var base64data = reader.result;
            this.imageURL = this.sanitizer.bypassSecurityTrustUrl(base64data.toString()) as string;
          }

        });
    }
  }


  onUpload(event) {
    for (const file of event.files) {
      this.pUpload = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.imageURL = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
    this.isImageUploaded = true;
  }
  onRemove(event) {
    this.pUpload = null;
    this.imageURL = '';
  }

  onReset() {
    this.userEditForm.reset();
    this.pUpload = null;
    this.imageURL = '';
    this.ctrlImageUpload['files'] = [];
    this.isImageUploaded = false;
    this.displayUserDialog = false;
  }

  ngAfterViewInit() {
    // this.showDocumentSecondaryNav = true;
    // this.changes.detectChanges();
    // this.openNav.nativeElement.click();
    // this.changes.detectChanges();

    var newElement = document.getElementById("activeLink")
    newElement.classList.add("active");
    this.changes.detectChanges();

  }

  checkPublicUsers() {
      this.userService.checkPublicUser().subscribe(res => {
      });
    
  }
  collapse() {
    this.isExpanded = false;
  }

  closemenu() {
    this.titleService.setTitle(this.title);
    toggleMenu();
  }

  //Authenticates current logged in user
  authenticateuser() 
  {
    var currentAccount = this.msalSvc.instance.getActiveAccount();
    this.getUserRole(this.msalSvc.instance.getActiveAccount().username);
    /*this.msalSvc.acquireTokenSilent(environment.MsalConfig.GraphUri)
    .subscribe((token: any)=> {
        if (!token) {
          this.nonEYEmpLogin();
        } else
         {
          if (sessionStorage.getItem('CurrentSession') == null|| sessionStorage.getItem('CurrentSession') == undefined)
           {
            this.manageUserSession(currentAccount.username);
           } 
           else
           {
             this.sessionReq = JSON.parse(sessionStorage.getItem('CurrentSession'));
              if (this.sessionReq) 
              {
               this.userService.updateSessionInfo(this.sessionReq).subscribe();
               this.isTokenRenewed = true;
              }
          }
          
          this.getUserRole(currentAccount.username);
        }
      } );*/
  }
  

  nonEYEmpLogin() {
    this.isPublicUserExist = 'Reader';
    localStorage.setItem('role', 'Reader');
    this.userName = this.globalReplacer('Public');
    this.userMemoryService.role = "reader"
  }

  //Gets role of current user
  getUserRole(email: any) {
    var currentAccount = this.msalSvc.instance.getActiveAccount();
    this.isPageReady = false;
    this.userService.getUserRole(email)
      .subscribe((response: any) => {
        if (!response.data) {
          this.logOutUserNotFound();
        } else {
          this.userData = response.data;
          if (this.userData.rankCode == 11 || this.userData.rankCode == 21 || this.userData.rankCode == 13) {
            this.showOnlyProfile = false;
          }
          else {
            this.showOnlyProfile = true;
          }
          this.isUserExist = 'hasaccess';
          sessionStorage.setItem('userName', currentAccount.name);
          sessionStorage.setItem('userEmail', currentAccount.username);
          this.userName = currentAccount.name;
          this.isAuthorizedUser = true;
          this.IsAdmin = response.data.isAdmin ? true : false;
          localStorage.setItem('IsAdmin', String(this.IsAdmin));
          localStorage.setItem('userModel', JSON.stringify(response.data));
          this.languageService.userDataSetter(response);
        }
        this.isPageReady = true;
      },
        (error) => {

          this.messageService.add({
            summary: 'error : Error occured while getting user role from server',
            // detail: data.message,
            sticky: false,
            severity: 'error'
          });
          // this.notifierService.notify('error', 'Error occured while getting user role from server');
          this.isPageReady = true;
        });


  }

  private manageUserSession(userName) {
    this.userService.addSessionInfo({ 'userEmail': userName })
      .subscribe((response: any) => {
        if (response && response.status == 1) {
          this.sessionReq.userEmail = userName;
          this.sessionReq.sessionId = response.message;
          sessionStorage.setItem('CurrentSession', JSON.stringify(this.sessionReq));

          if (!response.data) {
            this.modalShow = true;
          }
        }
      });
  }  

  hideModal(response: any) {

    if (response == "Yes") {
      this.modalShow = false;
      this.refreshUserState();
      this.userService.endOtherActiveSession(this.sessionReq).subscribe();
    } else {

      this.modalShow = false;
      this.userService.endSessionInfo(this.sessionReq).subscribe((response: any) => {
        if (!response.data) {
          this.logout();
        }

      });
    }
  }

  proceedsession() {
    this.renewToken();
  }

  endsession() {
    this.showConfirmation = false;
    this.logout();
  }

  logout() {
    this.sessionReq = JSON.parse(sessionStorage.getItem('CurrentSession'));
    clearTimeout(this.userActivity);
    clearTimeout(this.userActivityAfterNotified);
    //this.userService.endSessionInfo(this.sessionReq).subscribe();
    this.userService.endSessionInfo(this.sessionReq).subscribe((response: any) => {
      if (!response.data) {
      } 
      this.showConfirmation = false;
      sessionStorage.clear();
      localStorage.clear()
      this.msalSvc.logout();
      this.isUserTriggredLogout = true;
      this.router.navigate["/home"];
    });
     
      }

   
    /*this.showConfirmation = false;
    sessionStorage.clear();
    localStorage.clear()
    this.msalSvc.logout();
    this.isUserTriggredLogout = true;
    this.router.navigate["/home"];*/

  

  logOutUserNotFound() {
    localStorage.clear();
    this.msalSvc.logout();
    this.isAuthorizedUser = false;
    this.router.navigate["/home"];
    //this.router.navigate(['/access-denied']);
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  changeLanguage(event: any) {
    if (event.value) {
      this.languagechanged=true;
      var values = this.languageList.filter(item => item.value == event.value)
      this.languageService.changeLanguage({ name: values[0].label, Id: values[0].value });
      sessionStorage.setItem('selectedLanguageId', event.value);
      this.lableCardService.getAllMappedLabels(event.value).subscribe
        (
          (resp) => {
            var languageList = resp;
            this.languageService.myDataSetter(languageList);
            // var url = window.location.href;
            // if(url.indexOf('&lang=') != -1){
            //   var newUrl=this.removeURLParameter(url,'lang');
            //   console.log(newUrl);
            // }
          });
    }
  }

  navigateToResource(): void {
    this.titleService.setTitle(this.title);
    this.aboutrestructuringlink = this.MappedLinksLanguage['RdcLinkURL'] ? this.MappedLinksLanguage['RdcLinkURL'] : this.MappedLinksEnglishLanguage['RdcLinkURL'];

    window.open(this.aboutrestructuringlink);
  }

  openAddEngagement() {
    this.titleService.setTitle(this.title);
    this.router.navigate(['/engagement-mgt']);
    var newElement = document.getElementById("addEngagement");
    var mgmtNav = document.getElementById("management_nav");
    var primaryEngMgmt = document.getElementById("primaryEngMgmt");

    if (mgmtNav) {
      mgmtNav.style.display = "block";
      newElement.classList.add("active");
      primaryEngMgmt.classList.add("active");
    }
    this.contactactive = false;
    this.showDocumentSecondaryNav = false;
  }

  loadFolderMgmt() {
    this.titleService.setTitle(this.title);
    this.router.navigate(['/app-config']);
    this.contactactive = false;
  }

  navigatetoActive() {
    this.titleService.setTitle(this.title);
    if (!this.isClickComplete) {
      this.router.navigate(['/home'], { queryParams: { engagementType: 'active' } });
      this.contactactive = false;
    }
  }

  eyInternalUserLogin() {
     if (this.msalSvc?.instance.getActiveAccount() == null) {
      this.msalSvc.loginRedirect();
      this.isUserTriggredLogout = true;
      
      
    } 
  }

  renewToken() {
    this.isPageReady = true;
    this.reset$.next(void 0);
      this.isPageReady = true;
      this.refreshUserState();
      this.showConfirmation = false;
      this.isTokenRenewed = true;
  }

  private getSeconds(ticks: number) {
    const seconds = ((ticks % 60000) / 1000).toFixed(0);
    return this.pad(seconds);
  }

  private getMinutes(ticks: number) {
    const minutes = Math.floor(ticks / 60000);
    return this.pad(minutes);
  }

  private pad(digit: any) {
    return digit <= 9 ? '0' + digit : digit;
  }

  ngDoCheck() {
    // console.log(this.managementNav);
    this.isExpanded = this.homeService.isHomeSelected
    if (this.isExpanded == true && !this.isClickComplete) {
      this.showAdminSecondaryNav = true;
      this.showEngSecondaryNav = false;
      this.showAdminSecondaryNav = false;
      let nav: HTMLElement = this.openNav.nativeElement;
      nav.click();
      this.isClickComplete = true;
    }
    if (!this.isExpanded) {
      this.isClickComplete = false;
    }
    this.route.queryParams.subscribe(params => {
      if (this.router.url == "/approval-mgt?navigateTo=approval" && params["navigateTo"] && params["navigateTo"] == "approval") {
        //if (this.managementNav) {
        this.showDocumentSecondaryNav = false;
        this.showAdminSecondaryNav = false;
        this.showEngSecondaryNav = true;
        this.showAdminSecondaryNav = false;

      }
    })
  }


  ngAfterViewChecked() {
  }
}
